var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42.358,
    height: 42.85,
    viewBox: "0 0 42.358 42.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-phone-forwarded",
    "data-name": "Icon feather-phone-forwarded",
    transform: "translate(-2.166 -0.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M28.5,1.5l7.728,7.728L28.5,16.956",
    transform: "translate(7.296)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M22.5,7.5H37.956",
    transform: "translate(5.568 1.728)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M41.592,31.826v5.8a3.864,3.864,0,0,1-4.212,3.864,38.234,38.234,0,0,1-16.673-5.931A37.674,37.674,0,0,1,9.115,23.962,38.234,38.234,0,0,1,3.184,7.212,3.864,3.864,0,0,1,7.028,3h5.8a3.864,3.864,0,0,1,3.864,3.323,24.807,24.807,0,0,0,1.352,5.429,3.864,3.864,0,0,1-.869,4.077l-2.454,2.454A30.912,30.912,0,0,0,26.31,29.874l2.454-2.454a3.864,3.864,0,0,1,4.077-.869A24.807,24.807,0,0,0,38.269,27.9a3.864,3.864,0,0,1,3.323,3.922Z",
    transform: "translate(0 0.432)",
    fill: "none",
    stroke: "#cea95a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.41e90b9d1d65b8fb690f9edcd4041867.svg";
export { ForwardRef as ReactComponent };